<div class="container">
    <div class="block-title">
        <div class="title">{{ 'SHARED.EXTERNAL.CMR.PHASE.COMMENT.CAPTION' | translate }}</div>
        <div class="subtitle">{{ 'SHARED.EXTERNAL.CMR.PHASE.COMMENT.HELP' | translate }}</div>
    </div>

    <div class="block-form">
        <textarea-component class="textarea" [(ngModel)]="comment" name="comment"
            placeholder="{{ 'SHARED.EXTERNAL.CMR.PHASE.COMMENT.PLACEHOLDER' | translate }}">
        </textarea-component>
    </div>

    <div class="block-buttons">
        <button class="btn-external primary" (click)="onSave()" [disabled]="!isValid() || sending">
            {{ 'SHARED.EXTERNAL.CMR.PHASE.COMMENT.SAVE' | translate }}</button>
    </div>
</div>
